export const secondsToMinutesAndSeconds = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  // Pad with zeros to ensure "MM:SS" format
  const paddedMinutes = String(minutes).padStart(2, "0");
  const paddedSeconds = String(remainingSeconds).padStart(2, "0");

  return {
    minutes: paddedMinutes,
    seconds: paddedSeconds,
  };
};

export const formatRelativeTime = (dateString: string): string => {
  if (!dateString) return "";

  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) return "Today";
  if (diffInDays === 1) return "1 day ago";
  return `${diffInDays} days ago`;
};

export const isOlderThanOneDay = (timestamp: string | number): boolean => {
  const targetDate = new Date(Number(timestamp));
  const now = new Date();
  const hoursSinceTarget =
    (now.getTime() - targetDate.getTime()) / (1000 * 60 * 60);
  return hoursSinceTarget >= 24;
};
